//
export default [
    {
        text: '#',
        value: 'id',
        width: '5%',
    },
    {
        text: 'código',
        value: 'code',
        width: '10%',
    },
    {
        text: 'nombre',
        value: 'name',
    },
    {
        text: 'cantidad',
        value: 'quantity',
        align: 'right',
        format: 'number',
        width: '10%',
    },
    {
        text: 'precio neto',
        value: 'net_price',
        align: 'right',
        format: 'currency',
        width: '10%',
    },
    {
        text: 'total neto',
        value: 'net_total',
        align: 'right',
        format: 'currency',
        width: '10%',
    },
]
